export const SET_PLAYBOOK_TYPE = 'SET_PLAYBOOK_TYPE';
export function setPlaybookType(playbookType) {
  return {
    type: SET_PLAYBOOK_TYPE,
    playbookType,
  };
}
